
<div style="min-height: 100vh;" class="authBg container-fluid">
  <div class="card-body">
    <div class="row">
      <div class="col-md-5 p-0 text-right login-image">
        <img class="mt-0 mb-3" src='assets/img/reset-password.svg' />
      </div>
      <div class="col-md-7 text-center">

        <!-- Email Verification -->
        <div class="login-form" >

  
        
          <!-- Success -->
          <div class="mt-3" *ngIf="success">                            
            <div class="login-form text-center sent-successfully">
              <mat-icon>check_circle_outline</mat-icon>
              <div class="text-center mb-3">
                <h1 class="text-blue">{{ 'YourEmailHasBeenVerifiedSuccessfully' | translate }}</h1>
              </div>
              <p class="text-center"><a class="back-to-login" (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a></p>
            </div>
          </div> 

          <div class="mt-3" *ngIf="!success">                            
            <div class="login-form text-center sent-successfully">
              <div><i class="fas fa-exclamation-circle red-icon"></i></div>
              <div class="text-center mb-3">
                <h1 class="text-danger">{{ "Sorry,ThislinkIsNoLongerValid" | translate }}</h1>
              </div>
              <p class="text-center"><a class="back-to-login" (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a></p>
            </div>
          </div> 


    



        </div>





      </div>
    </div>
  </div>
</div>


